import React, {useEffect, useState} from 'react';
import './DealerConnect.css';
import PropTypes from 'prop-types';
import {submitDealerSearch} from '../../Services/SubmitDealerSearchService/SubmitDealerSearchService';
import DealerDisplay from '../DealerDisplay/DealerDisplay';
import {updateDealerSearchString, updateDealerSearchType} from '../../redux/app-state-slice';
import {initialState} from '../../redux/initialState';

import errorIcon from '../../assets/icons/error.svg';
import closeIcon from '../../assets/icons/close-blue.svg';
import RadioButton from '../RadioButton/RadioButton';

export const createDealerDisplayHtml = (dealerDetails, dispatch, hasSelectButton, appConfig, customerData) => {
  const dealers = [];
  if (dealerDetails?.dealers?.length === 0 || dealerDetails?.dealers?.length === undefined) {
    dealers.push(
      <h3 key={0} data-testid='dealer-display-test'>
        {' '}
        No Dealers Found{' '}
      </h3>
    );
  } else {
    for (let i = 0; i < dealerDetails.dealers.length; i++) {
      dealers.push(
        <DealerDisplay
          key={i + 1}
          sequence={i + 1}
          dealerDetails={dealerDetails.dealers[i]}
          hasSelectButton={hasSelectButton}
          dispatch={dispatch}
          appConfig={appConfig}
          customerData={customerData}
        />
      );
    }
  }
  return dealers;
};
export const validateSearchResult = (result) => {
  if (result?.dealers?.length === 0) {
    return 'No results found. Please try again.';
  }
  return '';
};
export const searchForDealers = (appConfig, customerData) => {
  const searchString = customerData?.dealerSearchString?.value;
  const searchType = customerData?.dealerSearchType?.value;
  if (searchString && searchString !== '') {
    const searchCriteria = {
      searchString,
      searchType,
      customerPostalCode: customerData?.postalCode?.value,
      customerUUID: customerData?.uuid,
      countryCode: customerData?.countryCode?.value
    };
    return submitDealerSearch(searchCriteria, appConfig);
  }
  return null;
};
export const toggleSearchType = (searchType) => {
  if (searchType === 'LOCATION') {
    return 'NAME';
  }
  return 'LOCATION';
};
export const getDealerSearchInfo = async (appConfig, customerData) => {
  if (customerData.dealerSearchString.hasError) {
    return {
      errorMessage: customerData.dealerSearchString.errorMessage
    };
  }
  const result = await searchForDealers(appConfig, customerData);
  const activeFlag = result?.dealers?.length <= 0;
  return {
    searchResults: result,
    errorMessage: customerData.dealerSearchString.errorMessage,
    activeFlag
  };
};

function DealerConnect({dispatch, customerData, appConfig, hasSelectButton}) {
  const [dealerSearchResponse, setSearchResult] = useState({dealers: []});
  const [errorMessage, setErrorMessage] = useState('');
  const [dealerSearchInput, setDealerSearchInput] = useState(customerData.dealerSearchString.value);

  const onClickRadioButton = () => {
    dispatch(updateDealerSearchType(toggleSearchType(customerData?.dealerSearchType?.value)));
    setErrorMessage('');
  };

  useEffect(() => {
    let customerPostalCode = customerData?.postalCode?.value;
    customerPostalCode =
      customerPostalCode && customerData.countryCode.value === 'USA' ? customerPostalCode.substring(0, 5) : customerPostalCode;
    dispatch(updateDealerSearchType('LOCATION'));
    dispatch(updateDealerSearchString(customerPostalCode));
    setDealerSearchInput(customerPostalCode);
    const searchCriteria = {
      searchString: customerPostalCode,
      searchType: 'LOCATION',
      customerUUID: customerData.uuid,
      countryCode: customerData.countryCode.value,
      customerPostalCode
    };

    async function search() {
      const result = await submitDealerSearch(searchCriteria, appConfig);
      setSearchResult(result);
    }

    search();
  }, []);
  const searchForDealerOnEvent = async () => {
    const searchInfo = await getDealerSearchInfo(appConfig, customerData);
    setSearchResult(searchInfo.searchResults);
    setErrorMessage(searchInfo.errorMessage);
  };
  const searchForDealerOnKeyDown = async (e) => {
    if (e.key === 'Enter') {
      return searchForDealerOnEvent();
    }
    return null;
  };

  const handleChange = (event) => {
    dispatch(updateDealerSearchString(event.target.value));
    setDealerSearchInput(event.target.value);
  };

  const handleClick = () => {
    setDealerSearchInput('');
  };

  return (
    <>
      <div className='prequal--web--search-container-parent-fomo' data-testid='dealer-connect-container'>
        <div className='prequal--web--list-container'>
          <div className='prequal--web--radio-fomo'>
            <span className='prequal--web--label-text prequal--web--padding-right-8'>Search by:</span>
            <div className='prequal-web-radio-container-fomo'>
              <RadioButton name='Location' checked={customerData?.dealerSearchType?.value === 'LOCATION'} onChange={onClickRadioButton} />
              <RadioButton name='Dealer Name' checked={customerData?.dealerSearchType?.value === 'NAME'} onChange={onClickRadioButton} />
            </div>
          </div>

          <br />

          <div>
            {errorMessage !== '' && (
              <p className='prequal--web--search-error-messages' data-testid='error-message'>
                <img src={errorIcon} alt='error' className='prequal--web--alert-icon' />
                {errorMessage}
              </p>
            )}
          </div>

          {customerData.countryCode.value === 'CAN' ? (
            <div className='prequal--web--input-search-container'>
              <input
                onKeyUp={(e) => {
                  dispatch(updateDealerSearchString(e.target.value));
                }}
                type='text'
                name='search dealer'
                className='prequal--web--inputSearch-fomo'
                data-testid='search-dealer-zipcode'
                placeholder={customerData?.dealerSearchType?.value === 'LOCATION' ? 'Postal Code' : 'Dealer Name'}
                onKeyDown={(e) => searchForDealerOnKeyDown(e)}
                onChange={handleChange}
                value={dealerSearchInput}
              />
              {dealerSearchInput.trim() && (
                <img
                  onClick={() => {
                    handleClick();
                    dispatch(updateDealerSearchString(''));
                  }}
                  src={closeIcon}
                  alt='clear search for dealer'
                  role='presentation'
                  data-testid='clear-dealer-search'
                />
              )}
            </div>
          ) : (
            <div className='prequal--web--input-search-container'>
              <input
                onKeyUp={(e) => {
                  dispatch(updateDealerSearchString(e.target.value));
                }}
                type='text'
                name='search dealer'
                className='prequal--web--inputSearch-fomo'
                data-testid='search-dealer-zipcode'
                placeholder={customerData?.dealerSearchType?.value === 'LOCATION' ? 'ZIP Code' : 'Dealer Name'}
                onKeyDown={(e) => searchForDealerOnKeyDown(e)}
                onChange={handleChange}
                value={dealerSearchInput}
              />
              {dealerSearchInput.trim() && (
                <img
                  onClick={() => {
                    handleClick();
                    dispatch(updateDealerSearchString(''));
                  }}
                  src={closeIcon}
                  alt='clear search for dealer'
                  role='presentation'
                  data-testid='clear-dealer-search'
                />
              )}
            </div>
          )}

          <div className='prequal--web--dealer-search-result-container'>
            <div className='prequal--web--dealer-display-container-parent'>
              <div className='prequal--web--dealer-display-container'>
                {dealerSearchResponse && createDealerDisplayHtml(dealerSearchResponse, dispatch, hasSelectButton, appConfig, customerData)}
              </div>
            </div>
          </div>
        </div>
        <div className='prequal--web-dealer-display-image-parent'>
          <div className='prequal--web--dealer-display-image-container-fomo' />
        </div>
      </div>
    </>
  );
}

DealerConnect.propTypes = {
  dispatch: PropTypes.func,
  customerData: PropTypes.object,
  appConfig: PropTypes.object,
  hasSelectButton: PropTypes.bool
};

DealerConnect.defaultProps = {
  dispatch: null,
  customerData: initialState,
  appConfig: null,
  hasSelectButton: false
};
export default DealerConnect;
